// project import
import pages from './pages';
import dashboard from './dashboard';
import manage from './manage';
import kontakt from './kontakt';
// import legal from './legal';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [dashboard, pages, manage, kontakt]
};

export default menuItems;
